/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Body/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Body({
  children,
  viewPath = "/DesignSystem/Body",
  text,
  size = "medium",
  weight,
  color,
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  marginBottom = 0,
  maxWidth = "auto",
  lineHeight = 1.2,
  textOverflow = "ellipsis",
  textTransform = "none",
  whiteSpace = "nowrap",
  textAlign = "left",
  display = "flex",
  flexGrow = 0
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 size={size}
 weight={weight}
 color={color}
 marginTop={marginTop}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginBottom={marginBottom}
 maxWidth={maxWidth}
 lineHeight={lineHeight}
 textOverflow={textOverflow}
 textTransform={textTransform}
 whiteSpace={whiteSpace}
 textAlign={textAlign}
 display={display}
 flexGrow={flexGrow}
/>
{children}
</React.Fragment>)
}